module.exports = __webpack_public_path__ + "media/images/icon-add-fill-f8813d5c88ed0ab2610b478712bc63c2.svg";